import React from 'react';

/**
 * Nt — «no translate».
 * Оборачивает текст (логины, имена, фамилии и прочие идентификаторы),
 * который НЕ должен переводиться Google Translate.
 *
 * Google Translate пропускает любой элемент с классом `notranslate`
 * и атрибутом translate="no".
 *
 * Использование:
 *   <Nt>{user.login}</Nt>
 *   <Nt as="div" className="font-bold">{partner.full_name}</Nt>
 */
export default function Nt({ children, as: Tag = 'span', className = '', ...rest }) {
    return (
        <Tag
            translate="no"
            className={`notranslate${className ? ' ' + className : ''}`}
            {...rest}
        >
            {children}
        </Tag>
    );
}
